<template>
    <div class="divPadre">
        <div class="divHijo">
            <div class="lado-izq">
                <div class="logo">
                    <img src="/img/horizontal-white-logo.png">
                </div>
            </div>
            <div class="lado-der" :class="showMensaje == true ? 'mensajeCentradoPadre' : ''">
                <div class="titulo mb-3">
                    <h1 class="text-uppercase"><small>Registro de aspirantes</small></h1>
                    <hr class="section-break" />
                </div>
                <div v-if="showFormulario">
                    <form autocomplete="off" @submit.prevent="postGuardarAspirantes()">
                        <vs-row class="mt-2">
                            <vs-col w="12" class="mt-3">
                                <p style="color:gray">* Todos los campos son obligatorios</p>
                            </vs-col>
                            <vs-col w="12" class="my-2">
                                <h1 class="heading-1">Información del aspirante</h1>
                                <div class="divider"><span></span></div>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Apellido paterno *"
                                    placeholder="Apellido paterno"
                                    v-model="apellido_paterno"
                                >
                                    <template #message-danger v-if="errorFields.includes('apellido_paterno')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Apellido materno *"
                                    placeholder="Apellido materno"
                                    v-model="apellido_materno"
                                >
                                    <template #message-danger v-if="errorFields.includes('apellido_materno')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Nombre *"
                                    placeholder="Nombre"
                                    v-model="nombre"
                                >
                                    <template #message-danger v-if="errorFields.includes('nombre')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input 
                                    id="escuelaProcedencia"
                                    label="Escuela de procedencia" 
                                    placeholder="Escuela de procedencia"
                                    @focus="focusEscuela()"
                                    v-model="escuela"
                                />
                                <div class="escuelaOpciones" v-if="mostrarOpciones && escuelaSearch[0]">
                                    <div v-for="(escuela, i) in escuelaSearch" :key="i" class="divisionLineas">
                                        <div class="mb-2">
                                            <p class="my-2" style="font-size: 0.7rem; opacity: 0.5"><strong>{{escuela.text}}</strong></p>
                                            <div v-for="opciones in escuela.opciones" :key="opciones.id" @click="selectEscuela(opciones)" style="cursor: pointer;" class="pl-2">
                                                <p><i v-if="opciones.cct">{{opciones.cct}} - </i>{{opciones.text}} <small>{{opciones.ciudad}}</small></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="escuela !== ''" @click="escuela = ''" class="tache">
                                    <i class="far fa-times-circle"></i>
                                </div>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-select
                                    filter
                                    label="Nivel académico *"
                                    placeholder="Nivel académico"
                                    :key="nivelId"
                                    :disabled="!niveles_academicos.length"
                                    v-model="nivel_academico"
                                >
                                    <vs-option v-for="option in niveles_academicos" :key="option.id"  :label="option.nivel" :value="option.id">
                                        {{option.nivel}}
                                    </vs-option>
                                    <template #message-danger v-if="errorFields.includes('nivel_academico')">
                                        Requerido
                                    </template>
                                </vs-select>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-select
                                    class="pb-0"
                                    filter
                                    label="Escuela de interés *"
                                    placeholder="Escuela de interés"
                                    :key="escuela_interesId"
                                    :loading="loading_escuela_interes"
                                    :disabled="!escuelas_interes.length"
                                    v-model="escuela_interes"
                                >
                                    <vs-option-group v-for="(escuelas, e) in escuelas_interes" :key="e">
                                        <div slot="title">
                                            {{escuelas.estado}}
                                        </div>
                                        <vs-option v-for="option in escuelas.instituciones" :key="option.id"  :label="option && option.ciudad && option.ciudad.ciudad ? option.institucion + ' (' + option.ciudad.ciudad + ')' : option.institucion" :value="JSON.stringify(option)">
                                            {{option.institucion}} <small> {{option && option.ciudad && option.ciudad.ciudad ? option.ciudad.ciudad : ''}}</small>
                                        </vs-option>
                                    </vs-option-group>
                                    <template #message-danger v-if="errorFields.includes('escuela_interes')">
                                        Requerido
                                    </template>
                                </vs-select>
                                <p class="m-0" style="padding: 10px 0px 10px 10px;">{{escuela_seleccionada.direccion}}</p>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-select
                                    filter
                                    label="Ciclo escolar *"
                                    placeholder="Ciclo escolar"
                                    :key="ciclo_escolarId"
                                    :disabled="!ciclos_escolares.length"
                                    :loading="loading_ciclos_escolares"
                                    v-model="ciclo_escolar"
                                >
                                    <vs-option v-for="option in ciclos_escolares" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                    <template #message-danger v-if="errorFields.includes('ciclo_escolar')">
                                        Requerido
                                    </template>
                                </vs-select>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-select
                                    filter
                                    label="Oferta académica *"
                                    placeholder="Oferta académica"
                                    :key="oferta_academicaId"
                                    :disabled="!ofertas_academicas.length"
                                    :loading="loading_oferta_academica"
                                    v-model="oferta_academica"
                                >
                                    <vs-option v-for="(option, i) in ofertas_academicas" :key="i"  :label="option.nombre" :value="option.id">
                                        {{option.nombre}}
                                    </vs-option>
                                    <template #message-danger v-if="errorFields.includes('oferta_academica')">
                                        Requerido
                                    </template>
                                </vs-select>
                            </vs-col>
                            <vs-col w="12" class="mt-3 mb-2">
                                <h1 class="heading-1">Información del familiar o tutor</h1>
                                <div class="divider"><span></span></div>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Apellido paterno *"
                                    placeholder="Apellido paterno"
                                    v-model="apellido_paterno_familiar"
                                >
                                    <template #message-danger v-if="errorFields.includes('apellido_paterno_familiar')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Apellido materno *"
                                    placeholder="Apellido materno"
                                    v-model="apellido_materno_familiar"
                                >
                                    <template #message-danger v-if="errorFields.includes('apellido_materno_familiar')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Nombre *"
                                    placeholder="Nombre"
                                    v-model="nombre_familiar"
                                >
                                    <template #message-danger v-if="errorFields.includes('nombre_familiar')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Número de contacto *"
                                    placeholder="Número de contacto "
                                    type="tel"
                                    @input="numeroMaximo()"
                                    v-model="numero_contacto"
                                >
                                    <template #message-danger v-if="errorFields.includes('numero_contacto')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-input
                                    label="Correo eléctronico *"
                                    placeholder="Correo eléctronico "
                                    type="email"
                                    v-model="correo_electronico"
                                >
                                    <template #message-danger v-if="errorFields.includes('correo_electronico')">
                                        Requerido
                                    </template>
                                </vs-input>
                            </vs-col>
                            <vs-col sm="12" lg="4" class="my-2">
                                <vs-select
                                    label="¿Cómo se enteró? *"
                                    placeholder="¿Cómo se enteró?"
                                    filter
                                    v-model="enterado"
                                >
                                    <vs-option-group v-for="(forma, i) in formaEnterado" :key="i">
                                        <div slot="title">
                                            {{forma.tipo}}
                                        </div>
                                        <vs-option v-for="(opciones, j) in forma.forma" :key="j" :label="opciones.text" :value="opciones.id">
                                            {{opciones.text}} 
                                        </vs-option>
                                    </vs-option-group>
                                    <template #message-danger v-if="errorFields.includes('enterado')">
                                        Requerido
                                    </template>
                                </vs-select>
                            </vs-col>
                            <vs-col  sm="12" lg="4" class="mt-3 ml-auto">
                                <div class="d-flex align-items-center">
                                    <div class="imgFondo mr-2">
                                        <p class="mb-0 noSeleccion" @click.right.prevent @keydown="keyDown" @copy.prevent @paste.prevent><strong>{{captcha}}</strong></p> 
                                    </div>
                                    <i class="fas fa-redo-alt" @click="getRechaptcha()"></i>
                                    <vs-input v-model="captura_captcha" placeholder="Escriba el código">
                                        <template #message-danger v-if="errorFields.includes('captcha')">
                                            Código incorrecto. Intento de nuevo
                                        </template>
                                    </vs-input>
                                </div>
                            </vs-col>
                            <vs-col w="12" class="mt-3 ml-auto">
                                <vs-row class="d-flex justify-content-end">
                                    <vs-col sm="12" lg="4" class="d-flex">
                                        <vs-checkbox v-model="aviso" class="mr-2">
                                        </vs-checkbox>
                                        <p class="mb-0">Acepto y autorizo que la información proporcionada sea utilizada con los fines señalados en nuestro <a href="/registro-prospecto/aviso-privacidad" target="_blank"> Aviso de privacidad.</a></p>
                                    </vs-col>
                                </vs-row>
                            </vs-col>
                            <vs-col w="12" class="mt-3 d-flex align-items-center">
                                <vs-button
                                    :disabled="aviso == false"
                                    flat
                                    class="ml-auto"
                                >
                                    Enviar información
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </form>  
                </div>
                <div v-if="showMensaje" :class="showMensaje == true ? 'mensajeCentrado' : ''">
                    <h2 class="mb-1"><i style="font-size:55px;" class="far fa-check-circle"></i></h2>
                    <h4 class="mb-3 text-uppercase"><small>Gracias por compartir tus datos, a la brevedad uno de nuestros ejecutivos se pondrá en contacto contigo para dar continuidad a tu solicitud.<br>
                    Tus datos serán utilizados únicamente con los fines autorizados de acuerdo a nuestro aviso de privacidad que puedes consultar <a href="/registro-prospecto/aviso-privacidad" target="_blank">aquí.</a></small></h4>
                    <vs-button
                        flat
                        @click="showFormulario = true, showMensaje = false"
                    >
                        Regresar al registro de aspirantes
                    </vs-button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import academico from '../../../api/requests/academico'
import admisiones from '../../../api/requests/admisiones'
export default {
    data(){
        return{
            showFormulario: true,
            showMensaje: false,
            apellido_paterno: '',
            apellido_materno: '',
            nombre: '',
            //ESCUELA DE PROCEDENCIA
            buscar: '',
            escuela: '',
            escuelaSearch: [],
            escuelaId: (new Date()).getTime(),
            mostrarOpciones: false,
            // NIVEL ACADÉMICO
            nivel_academico: '',
            niveles_academicos: [],
            nivelId: (new Date()).getTime(),
            // ESCUELA DE INTERES
            escuela_interes: '',
            escuela_interesId: (new Date()).getTime(),
            escuelas_interes: [],
            loading_escuela_interes: false,
            escuela_seleccionada: [],
            // CICLOS ESCOLARES
            ciclo_escolar: '',
            ciclos_escolares: [],
            ciclo_escolarId: (new Date()).getTime(),
            loading_ciclos_escolares: false,
            // OFERTA ACADEMICA
            oferta_academica: '',
            ofertas_academicas: [],
            oferta_academicaId: (new Date()).getTime(),
            loading_oferta_academica: false,
            // FAMILIAR
            nombre_familiar: '',
            apellido_paterno_familiar: '',
            apellido_materno_familiar: '',
            numero_contacto: '',
            correo_electronico: '',
            enterado: '',
            formaEnterado: [
                {   
                    'tipo': 'Redes Sociales',
                    'forma':[
                        {'id': 1, 'text': 'Facebook'},
                        {'id': 5, 'text': 'Google Maps'},
                        {'id': 2, 'text': 'Instagram'},
                        {'id': 3, 'text': 'Twitter'},
                        {'id': 6, 'text': 'Whatsapp'},
                        {'id': 4, 'text': 'Youtube'},
                    ]
                },
                {
                    'tipo': 'Impresos',
                    'forma':[
                        {'id': 7, 'text': 'Flyers'},
                        {'id': 12, 'text': 'Invitaciones'},
                        {'id': 9, 'text': 'Lonas'},
                        {'id': 10, 'text': 'Pósters'},
                        {'id': 8, 'text': 'Trípticos'},
                        {'id': 11, 'text': 'Volantes'},
                    ]
                },
                {
                    'tipo': 'Tadicionales',
                    'forma':[
                        {'id': 15, 'text': 'Espectaculares'},
                        {'id': 14, 'text': 'Radio'},
                        {'id': 16, 'text': 'Sitio Web'},
                        {'id': 13, 'text': 'Tradicionales'},
                    ]
                },
                {
                    'tipo': 'Otros',
                    'forma':[
                        {'id': 18, 'text': 'Convenios'},
                        {'id': 22, 'text': 'Display'},
                        {'id': 21, 'text': 'Mailing'},
                        {'id': 19, 'text': 'Open House'},
                        {'id': 17, 'text': 'Visitas'},
                        {'id': 20, 'text': 'Voz en voz'},
                    ]
                }
            ],
            timeOut: null,
            captcha: '',
            captura_captcha: '',
            enterado_url: '',
            id_institucion_url: '',
            errorFields: [],
            aviso: false
        }
    },
    created(){
        this.getRechaptcha()
        let params = (new URL(document.location)).searchParams;
        this.enterado_url = params.get('tracking_code');
        this.id_institucion_url = params.get('id');
        this.getNivelAcademicoAspirante()
    },
    mounted() {
        const searchInput = $('#escuelaProcedencia');
        const vm = this
        let timeout = null;
        searchInput.on('input', function() {
            if(vm.escuela.length > 3 ) {
                if (timeout !== null) {
                    clearTimeout(timeout);
                }

                timeout = setTimeout(function() {
                    vm.getEscuelasProcedencia()
                }, 1000); 
            }else{
                vm.mostrarOpciones = false
                vm.escuelaSearch = []
                if (timeout !== null) {
                    clearTimeout(timeout);
                }
            }
        });
    },
    methods:{
        keyDown(e){
            console.log(e)
        },
        async getRechaptcha(){
            const {data: response} = await admisiones.getRechaptcha()
            this.captcha = response
        },
        numeroMaximo(){
            if(this.numero_contacto.length > 10){ 
                this.numero_contacto = this.numero_contacto.slice(0, 10);
            }
        },
        async getEscuelasProcedencia() {
                try{
                    const params = {
                        buscar: this.escuela
                    }
                    const { data: response } = await admisiones.getEscuelasProcedencia(params)
                    this.escuelaSearch = response
                    this.escuelaId = (new Date()).getTime()
                    this.mostrarOpciones = true
                }catch{

                }
        },
        focusEscuela(){
            if(this.escuelaSearch[0] && this.escuela != ''){
                this.mostrarOpciones = true
            }
        },
        selectEscuela(info){
            this.escuelaIdSelect = info.id
            this.escuela = info.text + ' (' + info.ciudad + ')'
            this.mostrarOpciones = false
        },
        async getNivelAcademicoAspirante(){
            try{
                const params = {}
                if(this.id_institucion_url == 2){
                    params.institucion_id = this.id_institucion_url
                }
                const { data: response } = await admisiones.getNivelAcademicoAspirante(this.id_institucion_url == 2 ? params : '')
                this.niveles_academicos = response
                this.nivelId = (new Date()).getTime()
            }catch(error){
                console.log(error)
            }
        },
        async getEscuelaInteresAspirante(){
            this.loading_escuela_interes = true
            try{
                const params = {}
                if(this.id_institucion_url == 2){
                    params.institucion_id = this.id_institucion_url
                }
                const { data: response } = await admisiones.getEscuelaInteresAspirante(this.nivel_academico, this.id_institucion_url == 2 ? params : '')
                this.loading_escuela_interes = false
                this.escuelas_interes = response
                this.escuela_interesId = (new Date()).getTime()
            }catch{
                this.loading_escuela_interes = false
            }
        },
        async getCiclosEscolaresAspitante(){
            this.escuela_seleccionada = JSON.parse(this.escuela_interes) 
            this.loading_ciclos_escolares = true
            try{
                const institucion = JSON.parse(this.escuela_interes)
                const { data: response } = await admisiones.getCiclosEscolaresAspitante(institucion.institucion_id)
                this.loading_ciclos_escolares = false
                this.ciclos_escolares = response
                this.ciclo_escolarId = (new Date()).getTime()
            }catch{
                this.loading_ciclos_escolares = false
            }
        },
        async getOfertaAcademicasAspirante(){
            this.loading_oferta_academica = true
            try{
                const institucion = JSON.parse(this.escuela_interes)
                const params = {
                    programa_id: institucion.programa_id,
                    ciclo_escolar_id: this.ciclo_escolar,
                    institucion_id: institucion.institucion_id
                }
                const { data: response } = await admisiones.getOfertaAcademicasAspirante(params)
                this.loading_oferta_academica = false
                this.ofertas_academicas = response
                this.oferta_academicaId = (new Date()).getTime()
            }catch{
                this.loading_oferta_academica = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.apellido_paterno) {
                this.errorFields.push('apellido_paterno')
            }
            if (!this.apellido_materno) {
                this.errorFields.push('apellido_materno')
            }
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.nivel_academico) {
                this.errorFields.push('nivel_academico')
            }
            if (!this.escuela_interes) {
                this.errorFields.push('escuela_interes')
            }
            if (!this.ciclo_escolar) {
                this.errorFields.push('ciclo_escolar')
            }
            if (!this.oferta_academica) {
                this.errorFields.push('oferta_academica')
            }
            if (!this.apellido_paterno_familiar) {
                this.errorFields.push('apellido_paterno_familiar')
            }
            if (!this.apellido_materno_familiar) {
                this.errorFields.push('apellido_materno_familiar')
            }
            if (!this.nombre_familiar) {
                this.errorFields.push('nombre_familiar')
            }
            if (!this.numero_contacto) {
                this.errorFields.push('numero_contacto')
            }
            if (!this.correo_electronico) {
                this.errorFields.push('correo_electronico')
            }
            if (!this.enterado) {
                this.errorFields.push('enterado')
            }

            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async postGuardarAspirantes(){
            if(this.sanityForm()){
                if(this.captura_captcha === this.captcha){
                    const loading = this.$vs.loading()
                    try{
                        const info = JSON.parse(this.escuela_interes)
                        const params = {
                            apellido_paterno: this.apellido_paterno,
                            apellido_materno: this.apellido_materno,
                            nombres: this.nombre,
                            escuela_procedencia_id: this.escuelaIdSelect,
                            escuela_de_interes: this.escuela_interes,
                            ciclo_escolar_id: this.ciclo_escolar,
                            oferta_academica_id: this.oferta_academica,
                            familiar_apellido_paterno: this.apellido_paterno_familiar,
                            familiar_apellido_materno: this.apellido_materno_familiar,
                            familiar_nombres: this.nombre_familiar,
                            familiar_telefono: this.numero_contacto,
                            familiar_correo: this.correo_electronico,
                            como_se_entero_id: this.enterado,
                            institucion_id: info.institucion_id,
                            programa_id: info.programa_id,
                            tracking_code: this.enterado_url,
                            origen: 'landing_marketing'
                        }
                        const { data: response } = await admisiones.postGuardarAspirantes(params)
                        this.apellido_paterno = ''
                        this.apellido_materno = ''
                        this.nombre = ''
                        this.escuela = ''
                        this.escuela_seleccionada = []
                        this.escuela_interes = ''
                        this.ciclo_escolar = ''
                        this.oferta_academica = ''
                        this.apellido_paterno_familiar = ''
                        this.apellido_materno_familiar = ''
                        this.nombre_familiar = ''
                        this.numero_contacto = ''
                        this.correo_electronico = ''
                        this.enterado = ''
                        this.captura_captcha = ''
                        this.showMensaje = true
                        this.showFormulario = false
                        this.getRechaptcha()
                        loading.close()
                    }catch{
                        loading.close()
                        this.$vs.notification({
                            color: 'danger',
                            duration: 'none',
                            icon: '<i class="far fa-times-circle"></i>',
                            title: 'Hubo un error',
                            text: 'Por favor de intentarlo más tarde.'
                        })
                        this.showFormulario = true
                    }
                }else{
                    this.getRechaptcha()
                    this.captura_captcha = ''
                    this.errorFields.push('captcha')
                }
            }
        }
    },
    watch:{
        nivel_academico(){
            this.escuela_interes = ''
            this.escuelas_interes = []
            this.ciclo_escolar = ''
            this.ciclos_escolares = []
            this.oferta_academica = ''
            this.ofertas_academicas = []
            this.getEscuelaInteresAspirante()
        },
        escuela_interes(){
            this.ciclo_escolar = ''
            this.ciclos_escolares = []
            this.oferta_academica = ''
            this.ofertas_academicas = []
            this.getCiclosEscolaresAspitante()
        },
        ciclo_escolar(){
            this.oferta_academica = ''
            this.ofertas_academicas = []
            this.getOfertaAcademicasAspirante()
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin phone {
  @media (min-width: 320px) { @content; }
}
@mixin tablet {
  @media (min-width: 769px) { @content; }
}
@mixin desktop {
  @media (min-width: 1024px) { @content; }
}


html, body {
	width: 100%;
	height: 100%;
    background: #ECEEF7;
}
.divPadre {
	width:100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    height: fit-content;
    @include desktop(){
	    height:100vh;
    }
}

.divHijo{
    width: 100%;
    height: 100%;
    margin: 3% 2%;
    background-color: #10284d; //#f5f5f5
    border-radius: 20px;
    @include desktop(){
        display: flex;
        width: 96%;
        height: 94%;
        margin: 0%;
    }
    position: relative;
    .lado-izq{
        width: 100%;
        padding: 1.5rem;
        border-radius: 20px 20px 0 0;
        @include desktop(){
            width: 25%;
            border-radius: 20px 0 0 20px;
            background-image: url('/img/maristas.png');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }
        .logo{
            margin: auto;
            @include phone(){
            text-align: center;
            }
            @include desktop(){
                width: fit-content;
                height: fit-content;
                text-align: left;
                // -moz-border-radius: 0 0 100% 0;
                // -webkit-border-radius: 0 0 100% 0;
                // border-radius: 0 0 100% 0;
            }
            img{
                max-width: 150px;
            }
        } 
    }
    .mensajeCentradoPadre{
        @include desktop(){
            display: flex;
            flex-direction: column;
        }
        .mensajeCentrado{
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }
    .lado-der{
        width: 100%;
        padding: 1.5rem;
        background-color: white;
        overflow: auto;
        border-radius: 0px 0px 20px 20px;
        @include desktop(){
            width: 75%;
            border-radius: 0px 20px 20px 0px;
        }
        .titulo{
            color: #354463;
            font-weight: bold;
            .section-break{
                background-color: transparent;
                border: 0;
                border-top: 1px solid #dbdbdb;//#fccf47;
                display: block;
                height: 0;
                width: 100%;
            }
        } 
        .heading-1 {
            font-size: 1.5em;
            letter-spacing: 0.08em;
            font-weight: 300;
            color: #354463;
            text-shadow: 0 1px 1px #FFFFFF;
            // text-transform: uppercase;
        }
        .divider {
            border-bottom: 1px solid #FADC85;
            background-color: #fff0c4;
            height: 2px;
            margin: 0.5em 0px 1.5em;
        }
        .divider span {
                display: block;
                width: 50px;
                height: 2px;
                background-color: #fccf47;
        }
        .escuelaOpciones{
            padding: 0 11px 10px 11px;
            position: absolute;
            z-index: 9;
            height: 150px;
            overflow-y: auto;
            box-shadow: 0px -10px 20px -5px rgba(0, 0, 0, var(--vs-shadow-opacity));
            background: white;
        }
        /* Estilos para motores Webkit y blink (Chrome, Safari, Opera... )*/
        .escuelaOpciones::-webkit-scrollbar {
            -webkit-appearance: none;
        }
        .escuelaOpciones::-webkit-scrollbar:vertical {
            width:10px;
        }
        .escuelaOpciones::-webkit-scrollbar-button:increment,.escuelaOpciones::-webkit-scrollbar-button {
            display: none;
        } 
        .escuelaOpciones::-webkit-scrollbar:horizontal {
            height: 10px;
        }
        .escuelaOpciones::-webkit-scrollbar-thumb {
            background-color: #9c9c9c;
            border-radius: 20px;
            border: 2px solid #f1f2f3;
        }
        .escuelaOpciones::-webkit-scrollbar-track {
            border-radius: 10px;  
        }
        .divisionLineas:not(:last-child){
            border-bottom: 1px solid #E5E7E9; 
        }
        .divisionLineas{
            padding: 2% 0;
        }
    }
    
    .lado-der::-webkit-scrollbar {
        -webkit-appearance: none;
    }
    .lado-der::-webkit-scrollbar:vertical {
        width:10px;
    }
    .lado-der::-webkit-scrollbar-button:increment,.lado-der::-webkit-scrollbar-button {
        display: none;
    } 
    .lado-der::-webkit-scrollbar:horizontal {
        height: 10px;
    }
    .lado-der::-webkit-scrollbar-thumb {
        background-color: #9c9c9c;
        border-radius: 20px;
        border: 2px solid #f1f2f3;
    }
    .lado-der::-webkit-scrollbar-track {
        border-radius: 10px;  
    }
    .aspirante{
        position:absolute;
        bottom: 0;
        left: 10%;
        border-radius: 50%;

        img{
            width: 50%;
        }
    }
    .noSeleccion{
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .imgFondo{
        background-image: url('/img/captcha.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        padding: 2% 3%;
        letter-spacing: 5px;
    }
    
    .tache{
        position: absolute;
        cursor: pointer;
        top: 20px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 2em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 2em);
        }

    }
}
</style>